import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class DegreeTypeTuitionFeeDeliveryMethodRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return indexableFilters.length === 3
			&& indexableFilters.some((_) => _.type === ParameterType.DELIVERY_METHOD)
			&& indexableFilters.some((_) => _.type === ParameterType.DEGREE_TYPE)
			&& indexableFilters.some((_) => _.type === ParameterType.TUITION_FEE);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.DEGREE_TUITION_FEE_DELIVERY_METHOD_ROUTE,
			params: {
				delivery_method: this.extractPath(filters.find((_) => _.type === ParameterType.DELIVERY_METHOD)),
				degree: this.extractPath(filters.find((_) => _.type === ParameterType.DEGREE_TYPE)),
				tuition_fee: this.extractPath(filters.find((_) => _.type === ParameterType.TUITION_FEE)),
			},
		};
	}
}
